import { _ as __rest } from './tslib.es6-292fd623.js';
import React__default from 'react';
import { MantineProvider as MantineProvider$1 } from '@mantine/core';
import { u as useMantineLocale, g as getMantineThemeOverride, N as NotificationsHandler } from './index-8d38edb6.js';
import { C as CustomStylesType } from './text-af71ddba.js';

const MantineProvider = (_a) => {
    var { children, locale, template = 'hb', customStyleType = CustomStylesType.NONE } = _a, props = __rest(_a, ["children", "locale", "template", "customStyleType"]);
    useMantineLocale(locale);
    return (React__default.createElement(MantineProvider$1, Object.assign({ theme: getMantineThemeOverride(locale, template, customStyleType) }, props),
        children,
        React__default.createElement(NotificationsHandler, null)));
};

export { MantineProvider as M };
